import { FC } from 'react';
import { BotSession } from './timelineTypes';
import { formatDateTime } from '../../utils/dateFormatter';
import HistoryCard from './HistoryCard';

interface BotSessionCardProps {
    sessions: BotSession[];
    onSessionClick: (session: BotSession) => void;
}

const BotSessionCard: FC<BotSessionCardProps> = ({ sessions, onSessionClick }) => {
    const historyItems = sessions.map((session) => {
        const { date, time } = formatDateTime(session.createdAt);
        return {
            id: session._id,
            title: session.dialogueFlowName,
            subtitle: `${date} | ${time}`,
        };
    });

    const handleItemClick = (item: any, index: number) => {
        onSessionClick(sessions[index]);
    };

    return <HistoryCard title='Chat Conversations' items={historyItems} onItemClick={handleItemClick} />;
};

export default BotSessionCard;
